
import { defineComponent, computed } from 'vue'
import Hamburger from '@/components/Buttons/ButtonHamburger.vue'

import useTheme from '@/composables/useTheme'

export default defineComponent({
  name: 'NavOne',
  components: {
    Hamburger,
  },
  setup() {
    const { currentTheme, currentMode } = useTheme()

    const buttonClasses = computed(() => {
      const {
        buttons: { ghost },
      } = currentTheme.value

      return [
        ghost.bg,
        ghost.hoverText,
        ghost.hoverBg,
        ghost.focusBg,
        ghost.focusText,
      ]
    })

    return {
      currentMode,
      currentTheme,
      buttonClasses,
    }
  },
})
